import { createContext } from 'react'
import type { Context } from 'react'
import type { WarehouseStateType } from 'storeContext/reducers/warehouse/types'
import type { WarehouseDispatchType } from 'storeContext/actions/warehouse/types'

export type WarehouseContextValueType = {
  state: WarehouseStateType
  dispatch: WarehouseDispatchType
}

// Keep the existing raw-state context default and Provider identity.
export const createWarehouseContext = (initialState: WarehouseStateType) =>
  createContext(initialState) as unknown as Context<WarehouseContextValueType>
